module.exports = __webpack_public_path__ + "media/images/icon-mask-magnifier-b491e6c578220bdddad88c4634824357.png";